<div class="source-code output-display">
  <div style="display: flex; justify-content: center">
    <div *ngFor="let i of textViewCellsRow1" class="output-char"><span>{{i.strValue}}</span></div>
  </div>
  <div style="display: flex; justify-content: center">
    <div *ngFor="let i of textViewCellsRow2" class="output-char"><span>{{i.strValue}}</span></div>
  </div>
</div>
